/* src/components/Blog/BlogItem.module.css */
.card {
  padding: 20px;
}
.anchor {
  display: block;
  text-decoration: none;
  color: inherit;
  overflow: hidden;
}

.title {
  font-size: 20px;
  line-height: 1.25;
  margin: 8px 0 6px 0;
  font-weight: 200;
}
.subtitle {
  font-size: 14px;
  margin: 0 0 6px 0;
  font-weight: 200;
}
.readTime {
  font-size: 12px;
  margin: 0 0 12px 0;
}
.imageWrap {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 10;
  margin-top: 8px;
}
.articleType {
  color: #ea3722;
}
.image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card:hover {
  background: #ececec;
}

@media (max-width: 768px) {
  .card {
    padding: 0;
  }
}